export const dddsData = [
  // Centro-Oeste
  { label: '61', value: '61', stateId: 'DF', regiao: 'Centro-Oeste' },
  { label: '62', value: '62', stateId: 'GO', regiao: 'Centro-Oeste' },
  { label: '64', value: '64', stateId: 'GO', regiao: 'Centro-Oeste' },
  { label: '65', value: '65', stateId: 'MT', regiao: 'Centro-Oeste' },
  { label: '66', value: '66', stateId: 'MT', regiao: 'Centro-Oeste' },
  { label: '67', value: '67', stateId: 'MS', regiao: 'Centro-Oeste' },

  // Nordeste
  { label: '82', value: '82', stateId: 'AL', regiao: 'Nordeste' },
  { label: '71', value: '71', stateId: 'BA', regiao: 'Nordeste' },
  { label: '73', value: '73', stateId: 'BA', regiao: 'Nordeste' },
  { label: '74', value: '74', stateId: 'BA', regiao: 'Nordeste' },
  { label: '75', value: '75', stateId: 'BA', regiao: 'Nordeste' },
  { label: '77', value: '77', stateId: 'BA', regiao: 'Nordeste' },
  { label: '85', value: '85', stateId: 'CE', regiao: 'Nordeste' },
  { label: '88', value: '88', stateId: 'CE', regiao: 'Nordeste' },
  { label: '98', value: '98', stateId: 'MA', regiao: 'Nordeste' },
  { label: '99', value: '99', stateId: 'MA', regiao: 'Nordeste' },
  { label: '83', value: '83', stateId: 'PB', regiao: 'Nordeste' },
  { label: '81', value: '81', stateId: 'PE', regiao: 'Nordeste' },
  { label: '87', value: '87', stateId: 'PE', regiao: 'Nordeste' },
  { label: '86', value: '86', stateId: 'PI', regiao: 'Nordeste' },
  { label: '89', value: '89', stateId: 'PI', regiao: 'Nordeste' },
  { label: '84', value: '84', stateId: 'RN', regiao: 'Nordeste' },
  { label: '79', value: '79', stateId: 'SE', regiao: 'Nordeste' },

  // Norte
  { label: '68', value: '68', stateId: 'AC', regiao: 'Norte' },
  { label: '96', value: '96', stateId: 'AP', regiao: 'Norte' },
  { label: '92', value: '92', stateId: 'AM', regiao: 'Norte' },
  { label: '97', value: '97', stateId: 'AM', regiao: 'Norte' },
  { label: '91', value: '91', stateId: 'PA', regiao: 'Norte' },
  { label: '93', value: '93', stateId: 'PA', regiao: 'Norte' },
  { label: '94', value: '94', stateId: 'PA', regiao: 'Norte' },
  { label: '69', value: '69', stateId: 'RO', regiao: 'Norte' },
  { label: '95', value: '95', stateId: 'RR', regiao: 'Norte' },
  { label: '63', value: '63', stateId: 'TO', regiao: 'Norte' },

  // Sudeste
  { label: '27', value: '27', stateId: 'ES', regiao: 'Sudeste' },
  { label: '28', value: '28', stateId: 'ES', regiao: 'Sudeste' },
  { label: '31', value: '31', stateId: 'MG', regiao: 'Sudeste' },
  { label: '32', value: '32', stateId: 'MG', regiao: 'Sudeste' },
  { label: '33', value: '33', stateId: 'MG', regiao: 'Sudeste' },
  { label: '34', value: '34', stateId: 'MG', regiao: 'Sudeste' },
  { label: '35', value: '35', stateId: 'MG', regiao: 'Sudeste' },
  { label: '37', value: '37', stateId: 'MG', regiao: 'Sudeste' },
  { label: '38', value: '38', stateId: 'MG', regiao: 'Sudeste' },
  { label: '21', value: '21', stateId: 'RJ', regiao: 'Sudeste' },
  { label: '22', value: '22', stateId: 'RJ', regiao: 'Sudeste' },
  { label: '24', value: '24', stateId: 'RJ', regiao: 'Sudeste' },
  { label: '11', value: '11', stateId: 'SP', regiao: 'Sudeste' },
  { label: '12', value: '12', stateId: 'SP', regiao: 'Sudeste' },
  { label: '13', value: '13', stateId: 'SP', regiao: 'Sudeste' },
  { label: '14', value: '14', stateId: 'SP', regiao: 'Sudeste' },
  { label: '15', value: '15', stateId: 'SP', regiao: 'Sudeste' },
  { label: '16', value: '16', stateId: 'SP', regiao: 'Sudeste' },
  { label: '17', value: '17', stateId: 'SP', regiao: 'Sudeste' },
  { label: '18', value: '18', stateId: 'SP', regiao: 'Sudeste' },
  { label: '19', value: '19', stateId: 'SP', regiao: 'Sudeste' },

  // Sul
  { label: '41', value: '41', stateId: 'PR', regiao: 'Sul' },
  { label: '42', value: '42', stateId: 'PR', regiao: 'Sul' },
  { label: '43', value: '43', stateId: 'PR', regiao: 'Sul' },
  { label: '44', value: '44', stateId: 'PR', regiao: 'Sul' },
  { label: '45', value: '45', stateId: 'PR', regiao: 'Sul' },
  { label: '46', value: '46', stateId: 'PR', regiao: 'Sul' },
  { label: '51', value: '51', stateId: 'RS', regiao: 'Sul' },
  { label: '53', value: '53', stateId: 'RS', regiao: 'Sul' },
  { label: '54', value: '54', stateId: 'RS', regiao: 'Sul' },
  { label: '55', value: '55', stateId: 'RS', regiao: 'Sul' },
  { label: '47', value: '47', stateId: 'SC', regiao: 'Sul' },
  { label: '48', value: '48', stateId: 'SC', regiao: 'Sul' },
  { label: '49', value: '49', stateId: 'SC', regiao: 'Sul' },
];


export const stateData = [
  // Centro-Oeste
  { label: 'DF', value: ['61'], regiao: 'Centro-Oeste' },
  { label: 'GO', value: ['62', '64'], regiao: 'Centro-Oeste' },
  { label: 'MT', value: ['65', '66'], regiao: 'Centro-Oeste' },
  { label: 'MS', value: ['67'], regiao: 'Centro-Oeste' },

  // Nordeste
  { label: 'AL', value: ['82'], regiao: 'Nordeste' },
  { label: 'BA', value: ['71', '73', '74', '75', '77'], regiao: 'Nordeste' },
  { label: 'CE', value: ['85', '88'], regiao: 'Nordeste' },
  { label: 'MA', value: ['98', '99'], regiao: 'Nordeste' },
  { label: 'PB', value: ['83'], regiao: 'Nordeste' },
  { label: 'PE', value: ['81', '87'], regiao: 'Nordeste' },
  { label: 'PI', value: ['86', '89'], regiao: 'Nordeste' },
  { label: 'RN', value: ['84'], regiao: 'Nordeste' },
  { label: 'SE', value: ['79'], regiao: 'Nordeste' },

  // Norte
  { label: 'AC', value: ['68'], regiao: 'Norte' },
  { label: 'AP', value: ['96'], regiao: 'Norte' },
  { label: 'AM', value: ['92', '97'], regiao: 'Norte' },
  { label: 'PA', value: ['91', '93', '94'], regiao: 'Norte' },
  { label: 'RO', value: ['69'], regiao: 'Norte' },
  { label: 'RR', value: ['95'], regiao: 'Norte' },
  { label: 'TO', value: ['63'], regiao: 'Norte' },

  // Sudeste
  { label: 'ES', value: ['27', '28'], regiao: 'Sudeste' },
  { label: 'MG', value: ['31', '32', '33', '34', '35', '37', '38'], regiao: 'Sudeste' },
  { label: 'RJ', value: ['21', '22', '24'], regiao: 'Sudeste' },
  { label: 'SP', value: ['11', '12', '13', '14', '15', '16', '17', '18', '19'], regiao: 'Sudeste' },

  // Sul
  { label: 'PR', value: ['41', '42', '43', '44', '45', '46'], regiao: 'Sul' },
  { label: 'RS', value: ['51', '53', '54', '55'], regiao: 'Sul' },
  { label: 'SC', value: ['47', '48', '49'], regiao: 'Sul' },
];


